const DOCUMENT = 'AGENCY_INVITE_';

const actions = {
  CHANGE_MARKUP: DOCUMENT + 'CHANGE_MARKUP',
  CHANGE_POSITION_PRICING: DOCUMENT + 'CHANGE_POSITION_PRICING',
  CHANGE_POSITION_ENABLED: DOCUMENT + 'CHANGE_POSITION_ENABLED',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CHANGE_STEP: DOCUMENT + 'CHANGE_STEP',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CREATE_REQUEST: DOCUMENT + 'CREATE_REQUEST',
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  TOUCH: DOCUMENT + 'TOUCH',
  UPDATE_REQUEST: DOCUMENT + 'UPDATE_REQUEST',
  SET_IS_NEW_AGENCY_CREATION: DOCUMENT + 'SET_IS_NEW_AGENCY_CREATION',
  LOAD_AGENTS_LIST_REQUEST: DOCUMENT + 'LOAD_AGENTS_LIST_REQUEST',
  LOAD_AGENTS_LIST_SUCCESS: DOCUMENT + 'LOAD_AGENTS_LIST_SUCCESS',
  LOAD_AGENCY_LEGAL_ENTITIES_REQUEST: DOCUMENT + 'LOAD_AGENCY_LEGAL_ENTITIES_REQUEST',
  LOAD_AGENCY_LEGAL_ENTITIES_SUCCESS: DOCUMENT + 'LOAD_AGENCY_LEGAL_ENTITIES_SUCCESS',
  LOAD_AGENCY_LEGAL_ENTITIES_ERROR: DOCUMENT + 'LOAD_AGENCY_LEGAL_ENTITIES_ERROR',
  CLEAR_AGENCY_LEGAL_ENTITIES: DOCUMENT + 'CLEAR_AGENCY_LEGAL_ENTITIES',
  AUTOFILL_CONTACT_INFORMATION: DOCUMENT + 'AUTOFILL_CONTACT_INFORMATION',
  CHANGE_PROPERTIES: DOCUMENT + 'CHANGE_PROPERTIES',
  CHANGE_DISTRICT_MARKUP: DOCUMENT + 'CHANGE_DISTRICT_MARKUP',
  CHANGE_POSITION_MARKUP: DOCUMENT + 'CHANGE_POSITION_MARKUP',

  changeMarkup: data => ({ type: actions.CHANGE_MARKUP, payload: data }),
  changePositionPricing: data => ({ type: actions.CHANGE_POSITION_PRICING, payload: data }),
  changePositionEnabled: data => ({ type: actions.CHANGE_POSITION_ENABLED, payload: data }),
  changeProperty: data => ({ type: actions.CHANGE_PROPERTY, payload: data }),
  changeStep: data => ({ type: actions.CHANGE_STEP, payload: data }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
  create: data => ({ type: actions.CREATE_REQUEST, payload: data }),
  loadData: data => ({ type: actions.LOAD_REQUEST, payload: data }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  saveError: data => ({ type: actions.SAVE_ERROR, payload: data }),
  saveSuccess: data => ({ type: actions.SAVE_SUCCESS, payload: data }),
  touch: () => ({ type: actions.TOUCH }),
  update: data => ({ type: actions.UPDATE_REQUEST, payload: data }),
  setIsNewAgencyCreation: data => ({ type: actions.SET_IS_NEW_AGENCY_CREATION, payload: data }),
  loadAgentsList: data => ({ type: actions.LOAD_AGENTS_LIST_REQUEST, payload: data }),
  loadAgentsListSuccess: data => ({ type: actions.LOAD_AGENTS_LIST_SUCCESS, payload: data }),
  loadAgencyLegalEntities: data => ({ type: actions.LOAD_AGENCY_LEGAL_ENTITIES_REQUEST, payload: data }),
  loadAgencyLegalEntitiesSuccess: data => ({ type: actions.LOAD_AGENCY_LEGAL_ENTITIES_SUCCESS, payload: data }),
  loadAgencyLegalEntitiesError: () => ({ type: actions.LOAD_AGENCY_LEGAL_ENTITIES_ERROR }),
  clearAgencyLegalEntities: () => ({ type: actions.CLEAR_AGENCY_LEGAL_ENTITIES }),
  autoFillContactInformation: data => ({ type: actions.AUTOFILL_CONTACT_INFORMATION, payload: data }),
  changeProperties: data => ({ type: actions.CHANGE_PROPERTIES, payload: data }),
  changeDistrictMarkup: data => ({ type: actions.CHANGE_DISTRICT_MARKUP, payload: data }),
  changePositionMarkup: data => ({ type: actions.CHANGE_POSITION_MARKUP, payload: data }),
};

export default actions;
